module.exports = __webpack_public_path__ + "static/media/ico_no_speaker.e97a6019.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ico_no_speaker.svg
// module id = 471
// module chunks = 1